import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import EcoPilot from '../../components/feature/EcoPilot';
import ContactContent from './components/ContactContent';

export default function Contact() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ContactContent />
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
    </div>
  );
}